/* ── Judge.me tekst-overschrijving — casual Nederlands ── */
(function () {
  'use strict';

  var replacements = [
    // Formeel intro-tekst vervangen door casual versie
    {
      from: /Hoe zou je dit product beoordelen\?[\s\S]*?zou willen delen\./gi,
      to: 'Wat vond je ervan?'
    },
    {
      from: /We zouden het op prijs stellen als je iets over je ervaring zou willen delen\./gi,
      to: ''
    },
    // Extra formele zinnen die Judge.me kan injecteren
    {
      from: /Vertel ons over je ervaring met dit product\./gi,
      to: 'Vertel ons wat je vond.'
    },
    {
      from: /Deel je ervaring met andere klanten\./gi,
      to: 'Laat andere shoppers weten wat je vond.'
    }
  ];

  function replaceText(node) {
    if (node.nodeType === Node.TEXT_NODE) {
      var original = node.textContent;
      var updated = original;
      replacements.forEach(function (r) {
        updated = updated.replace(r.from, r.to);
      });
      if (updated !== original) {
        node.textContent = updated;
      }
    } else if (
      node.nodeType === Node.ELEMENT_NODE &&
      !['SCRIPT', 'STYLE', 'NOSCRIPT'].includes(node.tagName)
    ) {
      node.childNodes.forEach(replaceText);
    }
  }

  function processWidget() {
    var widgets = document.querySelectorAll('.jdgm-widget, .jdgm-form, .jdgm-rev-widg');
    widgets.forEach(replaceText);
  }

  // Run zodra DOM geladen is
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', processWidget);
  } else {
    processWidget();
  }

  // Observeer Judge.me lazy-loading
  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (node) {
        if (node.nodeType === Node.ELEMENT_NODE) {
          if (
            node.classList &&
            (node.classList.contains('jdgm-widget') ||
              node.classList.contains('jdgm-form') ||
              node.querySelector('.jdgm-widget, .jdgm-form'))
          ) {
            replaceText(node);
          }
        }
      });
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();
